import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import * as actions from './passenger-information-input-modal.actions';
import { PassengerInformationInputModalState } from './passenger-information-input-modal.state';

/**
 * passengerInformationInputModal initial state
 */
export const passengerInformationInputModalInitialState: PassengerInformationInputModalState = {
  model: null,
};

/**
 * List of basic actions for PassengerInformationInputModal Store
 */
export const passengerInformationInputModalReducerFeatures: ReducerTypes<
  PassengerInformationInputModalState,
  ActionCreator[]
>[] = [
  on(actions.setPassengerInformationInputModal, (_state, payload) => ({ ...payload })),

  on(actions.updatePassengerInformationInputModal, (state, payload) => ({ ...state, ...payload })),

  on(actions.resetPassengerInformationInputModal, () => passengerInformationInputModalInitialState),
];

/**
 * PassengerInformationInputModal Store reducer
 */
export const passengerInformationInputModalReducer = createReducer(
  passengerInformationInputModalInitialState,
  ...passengerInformationInputModalReducerFeatures
);
